import { defineComponent as _defineComponent } from 'vue'
import { computed, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckbox',
  props: {
    color: null,
    value: { type: Boolean },
    isReadonly: { type: Boolean },
    isDisabled: { type: Boolean },
    isIndeterminate: { type: Boolean },
    type: { default: 'checkbox' },
    name: null
  },
  emits: ['update:value'],
  setup(__props: any, { emit }) {

const props = __props as { color?: string, value?: boolean, isReadonly?: boolean, isDisabled?: boolean, isIndeterminate?: boolean, type: 'checkbox' | 'button', name?: string }





const checkboxId = computed(() => {
    return props.name || `base-checkbox-${Math.random().toString(36).substring(2, 11)}`;
});

const getCheckboxCustomColor = computed<{ [key: string]: string }>(() => {
    return props.value ?
        { 'background-color': props.color, 'border-color': props.color } : {};
});

const getClasses = computed(() => {
    const classes = {
        '--active' : props.value || props.isIndeterminate,
        '--disabled': props.isDisabled,
        '--read-only': props.isReadonly,
        '--indeterminate': props.isIndeterminate,
        '--is-button-type': props.type === 'button',
    };

    return Object.keys(classes).filter((key) => classes[key]).join(' ');
});

const onInput = (event) => {
    if (!props.isReadonly && !props.isDisabled) {
        emit('update:value', event.target.checked);
    } else {
        event.preventDefault();
    }
};

const handleLabelClick = (event) => {
    if (props.type === 'button' && !props.isReadonly && !props.isDisabled) {
        const target = event.target as HTMLElement;
        if (target.tagName === 'BUTTON' || target.tagName === 'INPUT') {
            return;
        }
        
        const input = event.currentTarget.querySelector(`#${checkboxId.value}`) as HTMLInputElement;
        if (input) {
            event.preventDefault();
            input.checked = !input.checked;
            emit('update:value', input.checked);
        }
    }
};

const handleButtonClick = (event) => {
    if (!props.isReadonly && !props.isDisabled) {
        event.preventDefault();
        const input = (event.currentTarget.closest('.base-checkbox') as HTMLElement)?.querySelector(`#${checkboxId.value}`) as HTMLInputElement;
        if (input) {
            input.checked = !input.checked;
            emit('update:value', input.checked);
        }
    }
};

return { __sfc: true,props, emit, checkboxId, getCheckboxCustomColor, getClasses, onInput, handleLabelClick, handleButtonClick }
}

})